// @ts-nocheck
import { get } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768';
const BASE_URL = `${API_URL}/api/v1/Superset`;
export const getSupersetGuestToken = async (dashboardUuid) => {
    const query = dashboardUuid ? `?dashboardUuid=${encodeURIComponent(String(dashboardUuid))}` : '';
    const response = await get(`${BASE_URL}/guest-token${query}`);
    return response?.data || response || {};
};
